// Whiskey Staffo: play a product's short video while the card is hovered.
(() => {
  if (!window.matchMedia('(hover: hover)').matches) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const start = (video) => {
    if (!video.src) video.src = video.dataset.src;
    const play = video.play();
    if (play) play.then(() => video.classList.add('is-playing')).catch(() => {});
  };

  const stop = (video) => {
    video.classList.remove('is-playing');
    video.pause();
    video.currentTime = 0;
  };

  document.addEventListener('mouseover', (event) => {
    const card = event.target.closest('.card-wrapper');
    if (!card || card.contains(event.relatedTarget)) return;
    const video = card.querySelector('.ws-hover-video');
    if (video) start(video);
  });

  document.addEventListener('mouseout', (event) => {
    const card = event.target.closest('.card-wrapper');
    if (!card || card.contains(event.relatedTarget)) return;
    const video = card.querySelector('.ws-hover-video');
    if (video) stop(video);
  });
})();

// Product page: hovering an image plays the video paired with it.
(() => {
  if (!window.matchMedia('(hover: hover)').matches) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const attach = () => {
    document.querySelectorAll('script.ws-media-videos').forEach((tag) => {
      tag.textContent.split(';;').forEach((line) => {
        const [mediaId, src] = line.trim().split('|');
        if (!mediaId || !src) return;
        document.querySelectorAll(`[data-media-id="${mediaId}"]`).forEach((item) => {
          const holder = item.querySelector('.product-media-container, .product__media') || item;
          if (holder.querySelector('.ws-hover-video')) return;
          if (getComputedStyle(holder).position === 'static') holder.style.position = 'relative';
          const video = document.createElement('video');
          video.className = 'ws-hover-video ws-hover-video--gallery';
          video.dataset.src = src;
          video.muted = true;
          video.loop = true;
          video.playsInline = true;
          video.preload = 'none';
          video.setAttribute('aria-hidden', 'true');
          holder.appendChild(video);
          item.addEventListener('mouseenter', () => {
            if (!video.src) video.src = video.dataset.src;
            const play = video.play();
            if (play) play.then(() => video.classList.add('is-playing')).catch(() => {});
          });
          item.addEventListener('mouseleave', () => {
            video.classList.remove('is-playing');
            video.pause();
            video.currentTime = 0;
          });
        });
      });
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', attach);
  else attach();
})();
